import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, View ,Form} from 'react-bootstrap';

import MaterialTable from 'material-table';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import { PatchedPagination } from '../services/PatchedPagination.js';
import Alert from 'react-bootstrap/Alert';
import './styles.css';
import Spinner from 'react-bootstrap/Spinner';
import RestServices from '../services/RestServices.js';
import Multiselect from 'multiselect-react-dropdown';
import zIndex from '@mui/material/styles/zIndex';

const pageSizes = [20, 25, 50, 100];

class index extends React.Component {
    _isMounted = false;
    state = {
        perPage: 20,
        pageNumber: 1,
        moveTo: false,
        search_key: '',
        showLoading:true,
        allItems:[],
        alertMessage:'',
        alert:0,
        
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadOrders()
    }
    
    
    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                pageNumber: 1
            });
            setTimeout(() => {
                this.loadOrders()
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({pageNumber: 1 });
        setTimeout(() => {
            this.loadOrders()
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            pageNumber: 1,
        });
        setTimeout(() => {
            this.loadOrders()
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ pageNumber: this.state.pageNumber+1 });
            setTimeout(() => {
                this.loadOrders()
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ pageNumber: this.state.pageNumber-1 });
            setTimeout(() => {
                this.loadOrders()
            }, 500);
        }
    };

     capitalizeFirstLetter(string) {
        if(string){
        const words = string.split(" ");
        for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
        return words.join(" ");
    }else{
        return string
    }

      }
    async loadOrders() {
    
        if (this._isMounted) {
            this.setState({showLoading: true });
        }
        await RestServices.GlobalGet(
            localStorage.getItem('FirebaseToken'),
            'cuelink/GetAllCampaigns?search_key='+this.state.search_key+'&pageNumber='+this.state.pageNumber+'&perPage='+this.state.perPage
        )
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.error){
                this.setState({
                    showLoading: false,
                    alert: 1,
                    alertMessage: responseData.error
                })
               } else{
                        
                    if (this._isMounted) {
                        this.setState({
                            showLoading: false,
                            alert: 0,
                            alertMessage: '',
                            allItems:responseData.campaigns,
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }
    
    
    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    

    getItemLink= async (item) => {
        this.setState({
            showLoading: true
        });
        
        await RestServices.GlobalGet(
            localStorage.getItem('FirebaseToken'),
            'cuelink/GetLink?url='+item.url+'&subid='+this.props.user.ProfileUniqeID
        )
        .then((response) => response.json())
            .then((responseData) => {
                this.setState({
                    showLoading: false
                });
                if(responseData.shorten_url){
                    window.open(responseData.shorten_url,'_blank')
                }else{
                    this.setState({
                        alert: 1,
                        alertMessage: 'Oops! Something went wrong. Please try again later....'
                    });
                }
                

            })
            .catch((err) => {
                
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });

    }
    render() {
        
        return (
          
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                            <h4 style={{ marginLeft: '1rem',marginRight: '1rem'}}>
                            Cashback Offer's 
                            </h4>
                </Row>

                <div>
                    <hr />
                </div>
                <Row className='form-group' style={{justifyContent: 'right',textAlign: 'right'}}>
                                <div>
                                    <Form.Control
                                        style={{
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />

                                </div>
                                <div>
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                            </div>
                        </Row>
          
               
                        {this.state.allItems &&<>
                        <Row className="category_list">
                        {this.state.allItems.map((item) => {
                                return (
                                    <Col
                                    key={'productid_' + item.id}
                                    xs={3}
                                    className="category_ibox"
                                    onClick={(bh) => this.getItemLink(item)}
                                    >
                                    <p className="category_icon">
                                        <img
                                            src={item.image}
                                        />
                                    </p>
                                        <p className="brandName">{item.name} </p>
                                        <p>Payout upto<span>{item.payout_type == 'Per Lead'?<b>Rs. {item.payout.toFixed(2)}</b>:<b>{item.payout.toFixed(2)}%</b>}</span>/ Sale</p>
                                    
                                </Col>); 
                                
                        })}
                                    
                    </Row>
                    </>}
                        

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.pageNumber > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.pageNumber < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.pageNumber}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.allItems.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.allItems.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                </Container>  
                
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(index);
